import Price from '../../common/Price';
import DateTime from '../../common/DateTime';
import PaymentMethod from '../PaymentMethod';
import Enum from '../../common/Enum';

export interface OrderPaymentTransactionMeta {
  change: Price | null;
}

export enum OrderPaymentTransactionStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  PENDING_REFUND = 'pending_refund',
  REFUNDING = 'refunding',
  REFUND_FAILED = 'refund_failed',
  REFUNDED = 'refunded',
}

export enum OrderPaymentTransactionType {
  PAYMENT = 'payment',
  REFUND = 'refund',
}

interface OrderPaymentTransaction {
  id: string;
  status: Enum<OrderPaymentTransactionStatus>;
  type: Enum<OrderPaymentTransactionType>;
  parent_id: OrderPaymentTransaction['id'] | null;
  store_id: string;
  user_id: string | null;
  order_id: string;
  external_id: string | null;
  method: Enum<PaymentMethod>;
  amount: Price;
  meta: OrderPaymentTransactionMeta;
  confirmed_at: DateTime | null;
  cancelled_at: DateTime | null;
  refunded_at: DateTime | null;
  refund_failed_at: DateTime | null;
  created_at: DateTime;
  updated_at: DateTime;
}

type BetterOrderPaymentTransaction = Exclude<OrderPaymentTransaction, 'method' | 'meta'> & (
  {
    method: Enum<Exclude<PaymentMethod, PaymentMethod.CASH>>,
    meta: { change: null },
  } | {
    method: Enum<PaymentMethod.CASH>,
    meta: { change: Price },
  }
);

export default BetterOrderPaymentTransaction;
